// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-l_gT","advertDetailContactItem__link":"c-l_gU","advertDetailContactItem__stub":"c-l_gV"};